import { PlayerStatistics } from '../types/playerStatistics';
import { http } from './http';
import { GetPlayerStatisticsUrl } from './urls';

export const getClientVersions = (stats: PlayerStatistics): string[] => {
  const versions =
    stats.clientVersions ??
    (stats as PlayerStatistics & { ClientVersions?: string[] }).ClientVersions;
  return Array.isArray(versions) ? versions : [];
};

const PlayerStatisticsService = {
  get: async (): Promise<PlayerStatistics> => {
    const req = new Request(GetPlayerStatisticsUrl(), { method: 'GET' });
    return await http<PlayerStatistics>(req);
  },
};

export default PlayerStatisticsService;
